import { combine, createEvent, createStore, sample } from 'effector'
import { isRequestPolicyEnforced, onBucketsUpdate } from '~/core/api'
import { hooks } from '~/core/router'
import { F, nay, T } from '~/shared/helpers'
import { $notificationTranslations } from './translations'

export const $show = createStore(false)

export const $message = combine(
  $show,
  $notificationTranslations,
  (show, { title }) => ({
    show,
    title,
  })
)

const navigationInitHook = createEvent()

// register the navigation hook
hooks.register(hooks.Init, navigationInitHook)

// hide notification, after successfull redirect to some new route
sample({
  clock: navigationInitHook,
  filter: () => nay(isRequestPolicyEnforced()),
  fn: F,
  target: $show,
})

// show notification as soon as some restrictions appear
sample({
  clock: [onBucketsUpdate, navigationInitHook],
  filter: isRequestPolicyEnforced,
  fn: T,
  target: $show,
})
